import { Injectable } from '@angular/core';
import {SessionStorageKey} from "@shared/constants/session-storage";

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  public get(key: SessionStorageKey): string | null {
    return sessionStorage.getItem(key);
  }

  public set(key: SessionStorageKey, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public remove(key: SessionStorageKey): void {
    sessionStorage.removeItem(key);
  }
}
